import React from "react";
import { Progress } from "antd";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";

interface IProgressMessage {
  progress: number;
  type: "upload" | "download";
}

const ProgressMessage = ({ progress, type }: IProgressMessage): JSX.Element => {
  return (
    <div style={{ width: "160px", display: "flex", padding: "2px" }}>
      {type === "download" ? <DownloadOutlined /> : <UploadOutlined />}
      <Progress percent={progress} size="small" />
    </div>
  );
};

export default ProgressMessage;
